import {
  VacationApplicationStatus,
  VacationApplicationType,
  DayOffApplicationStatus,
  DayOffApplicationType,
} from '../../api-client';

// Vacation Application Status
const VACATION_STATUS_ORDER = [
  VacationApplicationStatus.PENDING,
  VacationApplicationStatus.ORDER_SIGNING,
  VacationApplicationStatus.ORDER_SIGNED,
  VacationApplicationStatus.CONFIRMED_BY_USER,
  VacationApplicationStatus.ACTIVE,
  VacationApplicationStatus.COMPLETED,
  VacationApplicationStatus.CANCELED,
];

export function vacationStatusAtLeast(
  current: VacationApplicationStatus,
  target: VacationApplicationStatus
): boolean {
  return VACATION_STATUS_ORDER.indexOf(current) >= VACATION_STATUS_ORDER.indexOf(target);
}

export function getVacationApplicationStatusLabel(status: VacationApplicationStatus): string {
  switch (status) {
    case VacationApplicationStatus.PENDING:
      return 'Ожидает рассмотрения';
    case VacationApplicationStatus.ORDER_SIGNING:
      return 'Ожидает подписания приказа';
    case VacationApplicationStatus.ORDER_SIGNED:
      return 'Приказ подписан';
    case VacationApplicationStatus.CONFIRMED_BY_USER:
      return 'Подтверждена пользователем';
    case VacationApplicationStatus.ACTIVE:
      return 'Активна';
    case VacationApplicationStatus.COMPLETED:
      return 'Завершена';
    case VacationApplicationStatus.CANCELED:
      return 'Отменено';
    default:
      return status;
  }
}

export function getVacationApplicationStatusBadgeVariant(
  status: VacationApplicationStatus
): string {
  switch (status) {
    case VacationApplicationStatus.PENDING:
      return 'warning';
    case VacationApplicationStatus.ORDER_SIGNING:
      return 'info';
    case VacationApplicationStatus.ORDER_SIGNED:
      return 'info';
    case VacationApplicationStatus.CONFIRMED_BY_USER:
      return 'primary';
    case VacationApplicationStatus.ACTIVE:
      return 'success';
    case VacationApplicationStatus.COMPLETED:
      return 'secondary';
    case VacationApplicationStatus.CANCELED:
      return 'danger';
    default:
      return 'secondary';
  }
}

// Vacation Application Type
export function getVacationApplicationTypeLabel(type: VacationApplicationType): string {
  switch (type) {
    case VacationApplicationType.PAID:
      return 'Оплачиваемый';
    case VacationApplicationType.UNPAID:
      return 'Без сохранения зарплаты';
    default:
      return type;
  }
}

export function getVacationApplicationTypeBadgeVariant(type: VacationApplicationType): string {
  switch (type) {
    case VacationApplicationType.PAID:
      return 'info';
    case VacationApplicationType.UNPAID:
      return 'warning';
    default:
      return 'secondary';
  }
}

// Day Off Application Status
const DAY_OFF_STATUS_ORDER = [
  DayOffApplicationStatus.PENDING,
  DayOffApplicationStatus.ORDER_SIGNING,
  DayOffApplicationStatus.ORDER_SIGNED,
  DayOffApplicationStatus.CONFIRMED_BY_USER,
  DayOffApplicationStatus.ACTIVE,
  DayOffApplicationStatus.COMPLETED,
  DayOffApplicationStatus.CANCELED,
];

export function dayOffStatusAtLeast(
  current: DayOffApplicationStatus,
  target: DayOffApplicationStatus
): boolean {
  return DAY_OFF_STATUS_ORDER.indexOf(current) >= DAY_OFF_STATUS_ORDER.indexOf(target);
}

export function getDayOffApplicationStatusLabel(status: DayOffApplicationStatus): string {
  switch (status) {
    case DayOffApplicationStatus.PENDING:
      return 'Ожидает рассмотрения';
    case DayOffApplicationStatus.ORDER_SIGNING:
      return 'Ожидает подписания приказа';
    case DayOffApplicationStatus.ORDER_SIGNED:
      return 'Приказ подписан';
    case DayOffApplicationStatus.CONFIRMED_BY_USER:
      return 'Подтверждена пользователем';
    case DayOffApplicationStatus.ACTIVE:
      return 'Активна';
    case DayOffApplicationStatus.COMPLETED:
      return 'Завершена';
    case DayOffApplicationStatus.CANCELED:
      return 'Отменено';
    default:
      return status;
  }
}

export function getDayOffApplicationStatusBadgeVariant(status: DayOffApplicationStatus): string {
  switch (status) {
    case DayOffApplicationStatus.PENDING:
      return 'warning';
    case DayOffApplicationStatus.ORDER_SIGNING:
      return 'info';
    case DayOffApplicationStatus.ORDER_SIGNED:
      return 'info';
    case DayOffApplicationStatus.CONFIRMED_BY_USER:
      return 'primary';
    case DayOffApplicationStatus.ACTIVE:
      return 'success';
    case DayOffApplicationStatus.COMPLETED:
      return 'secondary';
    case DayOffApplicationStatus.CANCELED:
      return 'danger';
    default:
      return 'secondary';
  }
}

// Day Off Application Type
export function getDayOffApplicationTypeLabel(type: DayOffApplicationType): string {
  switch (type) {
    case DayOffApplicationType.PAID:
      return 'Оплачиваемый';
    case DayOffApplicationType.UNPAID:
      return 'Без сохранения зарплаты';
    default:
      return type;
  }
}

export function getDayOffApplicationTypeBadgeVariant(type: DayOffApplicationType): string {
  switch (type) {
    case DayOffApplicationType.PAID:
      return 'info';
    case DayOffApplicationType.UNPAID:
      return 'warning';
    default:
      return 'secondary';
  }
}
